if (!customElements.get("m-image-comparison")) {
  class MImageComparison extends HTMLElement {
    constructor() {
      super();
      this.active = false;
      this.button = this.querySelector("button");
      // --- 保持不变 ---
      if (!this.button) {
          console.error("m-image-comparison: Button element not found!");
          return;
      }
      this.horizontal = this.dataset.layout === "horizontal";
      this.init(); // 保持调用 init
      if (this.hasAttribute("data-animation")) {
        // --- 保持不变 ---
        // 使用 rAF 确保 MinimogTheme 可用
        requestAnimationFrame(() => {
            if (typeof MinimogTheme !== 'undefined' && MinimogTheme.initWhenVisible) {
                MinimogTheme.initWhenVisible({
                    element: this.querySelector(".m-image-comparison__slider-animation"),
                    callback: this.animation.bind(this),
                    threshold: 0,
                });
            }
        });
      }
    }

    // --- 新增代码 开始 ---
    // 这个方法在元素加载到页面后运行
    connectedCallback() {
        // 使用 requestAnimationFrame 确保元素尺寸已计算
        requestAnimationFrame(() => {
            this.setInitialPosition();
        });
    }

    // 这个新函数用来设置初始位置
    setInitialPosition() {
        // 只在水平布局时设置初始为 80%
        if (this.horizontal) {
            const distance = this.clientWidth; // 获取容器宽度
            const initialPositionValue = distance * 0.8; // 计算 80% 宽度
            this.scroll(initialPositionValue); // 应用位置
        }
        // 对于垂直布局 (this.horizontal 为 false)，它将保持 CSS 的默认值 (很可能是 50%)
    }
    // --- 新增代码 结束 ---

    init() {
      // --- 保持不变 ---
      this.button.addEventListener("touchstart", this.start.bind(this), { passive: false }); // 添加 passive false
      document.body.addEventListener("touchend", this.end.bind(this));
      document.body.addEventListener("touchmove", this.onMove.bind(this), { passive: false }); // 重命名为 onMove 并添加 passive false

      this.button.addEventListener("mousedown", this.start.bind(this));
      document.body.addEventListener("mouseup", this.end.bind(this));
      document.body.addEventListener("mousemove", this.onMove.bind(this)); // 重命名为 onMove
    }

    animation() {
      // --- 保持不变 ---
      this.setAttribute("is-visible", "");
      this.classList.add("m-animating");
      setTimeout(() => {
        this.classList.remove("m-animating");
      }, 1e3);
    }

    start(e) { // 传入事件 e
      // --- 保持不变 ---
      document.documentElement.classList.add("prevent-scroll");
      this.active = true;
      this.classList.add("image-comparing");
      // 可选：改变光标
      if (this.button.firstElementChild) this.button.firstElementChild.style.cursor = 'grabbing';
    }

    end() {
      // --- 保持不变 ---
      document.body.style.removeProperty("padding-right");
      document.documentElement.classList.remove("prevent-scroll");
      this.active = false;
      this.classList.remove("image-comparing");
      // 可选：恢复光标
      if (this.button.firstElementChild) this.button.firstElementChild.style.cursor = '';
    }

    // 将 onStart 重命名为 onMove
    onMove(e) {
      if (!this.active) return;
       // --- 保持不变，但使用更精确的坐标计算 ---
      if (e.touches) { e.preventDefault(); } // 阻止触摸滚动
      const event = (e.touches && e.touches[0]) || e;
      const rect = this.getBoundingClientRect(); // 获取元素位置
      const x = this.horizontal
                ? event.clientX - rect.left // 相对于元素左侧
                : event.clientY - rect.top; // 相对于元素顶部
      this.scroll(x);
    }

    scroll(x) {
      const distance = this.horizontal ? this.clientWidth : this.clientHeight;
      // --- 保持不变 (边界限制) ---
      const max = distance - 1; // 稍微调整边界
      const min = 1;
      const mouseX = Math.max(min, Math.min(x, max));
      const mousePercent = (mouseX * 100) / distance;
      this.style.setProperty("--percent", mousePercent + "%");
    }
  }
  customElements.define("m-image-comparison", MImageComparison);
}